import React from "react";

import { Delete as DeleteIcon } from "icons";

import { Typography, Button } from "clearsense-ui/components";

const Delete = ({ setIsDeleteAlertOpen }) => (
  <div className="space-y-4">
    <Typography style="h4" className="border-b-2">
      Danger Zone
    </Typography>
    <div className="flex justify-between items-center">
      <div className="mb-4">
        <Typography style="h5">Delete Connection</Typography>
        <Typography className="text-xs text-gray-500">
          No data will be deleted from your source and destination. This cannot
          be un-done without a full re-sync
        </Typography>
      </div>
      <Button
        className="bg-red-700"
        label="Delete"
        icon={DeleteIcon}
        iconPosition="left"
        onClick={() => setIsDeleteAlertOpen(true)}
        data-cy="delete-connection-button"
      />
    </div>
  </div>
);

export default Delete;
